type CustomerSupportNameConcatT = {
  forename: string;
  lastname: string;
};

export function customerSupportNameConcat(customerSupport: CustomerSupportNameConcatT): string {
  return `${customerSupport.forename} ${customerSupport.lastname}`;
}
